import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { OrgaoUsuarioSiape } from "./EditSiape";
import { ButtonBack } from "../Button/Back";
import { getMessagemErro } from "../../utils/erro";
import api from "../../services/api";
import './AutoCadastroUsuario.css';
import { ID_SITUACAO_AUTO_CADASTRO_USUARIO_REPROVADA } from "../../providers/constSituacoesAutoCadastroUsuario";
import { ID_ESTADUAL, ID_MUNICIPAL } from "../../providers/constEsferasAdministrativas";
import { AutoCadastroUsuarioHistory } from "./History";

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
	}
}

export const AutoCadastroUsuarioView =

withRouter(

// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				solicitacao: {
					id: '',
					nomeUsuario: '',
					nomeSituacao: '',
					emailUsuario: '',
					siape: false,
					cnpjOrgao: '',
					nomeOrgao: '',
					siglaOrgao: '',
					nomeEsferaAdministrativaOrgao: '',
					ufOrgao: '',
					nomeAtribuicaoUsuario: '',
					justificativa: '',
				},
			};
		}

		componentDidMount(){
			this.props.limpaMensagem();
			const id = this.props.match.params.id;

			api.get(`/api/auto-cadastro-usuario/${id}`)
				.then(response => { 
					const solicitacao = response.data;
					this.setState({ solicitacao }) 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar a solicitação de cadastro de usuário.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				});
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					<div style={{margin: "10px"}}>
						<h1>Solicitação de Cadastro de Usuário</h1>
					</div>
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		renderForm() {
			const solicitacao = this.state.solicitacao;
			const user = this.props.user;

			return(
				<div className="container-fluid">
					<div className="br-form">
						<div className="row">
							<div className="col-sm-2">
								<div className="field">
									<div className="input">
										<label>CPF:</label>
										<input value={solicitacao.id} disabled/>
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Nome:</label>
										<input value={solicitacao.nomeUsuario} disabled/>
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Situação:</label>
										<input value={solicitacao.nomeSituacao} disabled/>
									</div>
								</div>
							</div>

						</div>

						{solicitacao.siape === true &&
							<OrgaoUsuarioSiape solicitacao={solicitacao} />
						}

						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Email:</label>
										<input type="email" value={solicitacao.emailUsuario} disabled/>
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-sm-2">
								<div className="field">
									<div className="input">
										<label>CNPJ do Órgão:</label>
										<input type="text" value={solicitacao.cnpjOrgao}  disabled	/>
									</div>
								</div>
							</div>

							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Nome do Órgão:</label>
										<input type="text" value={solicitacao.nomeOrgao}  disabled	/>
									</div>
								</div>
							</div>

							<div className="col-sm-2">
								<div className="field">
									<div className="input">
										<label>Sigla do Órgão:</label>
										<input type="text" value={solicitacao.siglaOrgao}  disabled	/>
									</div>
								</div>
							</div>

							<div className="col-sm-2">
								<div className="field">
									<div className="input">
										<label>Esfera Administrativa do Órgão:</label>
										<input value={solicitacao.nomeEsferaAdministrativaOrgao} disabled/>
									</div>
								</div>
							</div>
							<div className="col-sm-2">
								<div className="field">
									<div className="input">
										<label>Unidade da Federação do Órgão:</label>
										<input value={solicitacao.ufOrgao} disabled/>
									</div>
								</div>
							</div>
						</div>

						{ solicitacao.esferaAdministrativaOrgao && (solicitacao.esferaAdministrativaOrgao === ID_ESTADUAL || solicitacao.esferaAdministrativaOrgao === ID_MUNICIPAL) &&
							<>
								<div className="row">
									{ solicitacao.esferaAdministrativaOrgao === ID_MUNICIPAL &&
										<div className="col-md">
											<div className="field">
												<div className="input">
													<label>Município:</label>
													<input value={solicitacao.nomeMunicipioIBGEOrgao} disabled/>
												</div>
											</div>
										</div>
									}
									<div className="col-sd">
										<div className="field">
											<div className="input">
												<label>Código IBGE:</label>
												<input value={solicitacao.esferaAdministrativaOrgao === ID_ESTADUAL ? solicitacao.codigoMunicipioIBGEOrgao.substring(0, 2) : solicitacao.codigoMunicipioIBGEOrgao} disabled/>
											</div>
										</div>
									</div>
								</div>
							</>
						}
						
						<div className="row">
							<div className="col-sm-2">
								<div className="field">
									<div className="input">
										<label>Atribuição:</label>	
										<input value={solicitacao.nomeAtribuicaoUsuario ? solicitacao.nomeAtribuicaoUsuario : ""} disabled/>					
									</div>
								</div>
							</div>
						</div>

						{Number(solicitacao.situacao) === ID_SITUACAO_AUTO_CADASTRO_USUARIO_REPROVADA && 
							<div className="row">
								<div className="col-md">  
									<div className="field">
										<div className="input"> 
											<label>Justificativa de rejeição:</label>
											<textarea value={solicitacao.justificativa} disabled/>
										</div>
									</div>
								</div>
							</div>
						}

						{solicitacao.situacao &&
							<div className="row">
								<div className="col-md">
								</div>
								<div className="col-sm-4">
									<div className="field">
										<div className="input">
											<label>Histórico:</label>
											{solicitacao.id &&
												<AutoCadastroUsuarioHistory solicitacao={solicitacao} user={user} key={solicitacao.situacao}/>
											}
										</div>
									</div>
								</div>
							</div>
						}

						{/* button actions */}
						<div className="actions-button">
							<div className="actions justify-content-start">

								{ solicitacao.analisePermitida &&
									<Link to={`/user-self-registration/approve/${solicitacao.id}`}>
										<button type="button" className="button is-primary">Analisar</button>
									</Link>
								}

								<ButtonBack />							
							</div>
						</div>
					</div>
				</div>
			);
		}
	}

) // redux
); // router